import React from 'react'
import { styled } from '@mui/material/styles'
import { useRef, ChangeEvent } from 'react'
import AttachmentIcon from '@mui/icons-material/Attachment'

const PREFIX = 'UploadButton'

const classes = {
  button: `${PREFIX}-button`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')({
  [`& .${classes.button}`]: {
    color: '#000',
    cursor: 'pointer',
    marginRight: '16px',
    padding: '2px 2px',
    display: 'inline-block',
  },
})

interface UploadButtonProps {
  onUpload: (event: ChangeEvent<HTMLInputElement>) => void
}

export const UploadButton = ({ onUpload }: UploadButtonProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  const handleClick = () => {
    inputRef.current?.click()
  }

  return (
    <Root>
      <AttachmentIcon className={classes.button} onClick={handleClick} />
      <input
        type="file"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={onUpload}
      />
    </Root>
  )
}
